<template>
  <!-- 主菜单 续费页面 -->
  <div id="xuFeiPage">
    <div class="titleWord">
      <van-divider :style="{ fontSize: '17px', marginTop: '30px' }">
        会员续费
      </van-divider>
    </div>
    <!-- 续费弹框 -->
    <van-popup
      v-model="show"
      closeable
      close-icon="close"
      @close="closePopup"
      position="top"
      :style="{ height: '100%', width: '100%' }"
    >
      <div id="xuFeiPage">
        <div class="titleWord">
          <van-divider :style="{ fontSize: '17px', marginTop: '30px' }">
            续费账号等级
          </van-divider>
        </div>
        <div class="line"></div>
        <div class="payMethodsxf">
          <div class="word word_1">可续费账号等级</div>
          <van-tag type="success" size="medium">
            {{ xufeiItem.productname }} ({{
              moment(xufeiItem.starttime).format("YYYY-MM-DD")
            }}
            - {{ moment(xufeiItem.endtime).format("YYYY-MM-DD") }}) </van-tag
          ><span style="color: #07c160">(已购)</span>
          <div class="word word_1">续费时长</div>
          <div class="chooseYear bottom-line">
            <div
              class="one"
              :class="{ yearActive: currentYearIndex === index }"
              v-for="(year, index) in years"
              :key="index"
              @click="changeYear(year, index)"
            >
              <p class="year">{{ year.salenumber }}年</p>
              <!-- <p class="yuan">
                <span>&yen;</span><span class="money">{{ year.newprice }}</span>
              </p>
              <p class="yuanold">
                <del
                  ><span>原价:</span
                  ><span class="money">{{ year.oriprice }}</span></del
                >
              </p> -->
              <p
                style="color: #a17d59; font-size: 16px; margin: 18px 0"
                class="year"
              >
                {{ year.discountname }}
              </p>
              <p>
                <van-tag color="#A17D59">{{ year.discountdesc }}</van-tag>
              </p>
            </div>
          </div>
          <div class="line"></div>

          <template v-if="isConpponma">
            <div class="word word_1">优惠信息</div>
            <van-field
              v-model="coupon"
              center
              clearable
              label="优惠码"
              placeholder="请输入优惠码"
              @clear="clearCoupon"
              :disabled="checked ? true : false"
            >
            </van-field>
            <van-cell title=" ">
              <template #right-icon>
                <span style="margin-right: 10px">确认使用优惠码</span>
                <van-checkbox
                  :disabled="coupon ? false : true"
                  @change="changeChecked"
                  v-model="checked"
                />
              </template>
            </van-cell>
            <van-cell title=" ">
              <template #right-icon>
                <span style="margin-right: 10px; color: green">{{
                  checked ? alertMessage_1 : ""
                }}</span>
              </template>
            </van-cell>
            <div class="line"></div>
          </template>
          <div @click="drawABill">
            <van-cell title="发票" is-link :value="invoiceWord" />
          </div>
        </div>
        <div class="line"></div>
        <div class="payMethodsxf">
          <div class="word word_1">请选择支付方式</div>
          <van-radio-group v-model="radioPay">
            <van-cell-group>
              <van-cell clickable @click="radioPay = '1'">
                <template #title>
                  <van-image width="30" height="30" :src="wxImg" />
                  <span class="custom-title">微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
              <!-- <van-cell clickable @click="radioPay = '2'">
                <template #title>
                  <van-image width="30" height="30" :src="zfbImg" />
                  <span class="custom-title">支付宝支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="2" />
                </template>
              </van-cell> -->
            </van-cell-group>
          </van-radio-group>
        </div>
        <van-submit-bar
          :disabled="totalPrice > 0 ? false : true"
          :price="totalPrice"
          button-text="去支付"
          :loading="loadingFlag ? true : false"
          @submit="onSubmit"
        >
          <!-- <del style="color: #ccc;">原价：{{ oldPrice | toDecimal }}</del> -->
        </van-submit-bar>
      </div>
    </van-popup>
    <!-- 合同内容 用户协议 -->
    <van-popup
      v-model="userAgreement"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
    >
      <div id="word_11"></div>
      <user-agreement-pop
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      ></user-agreement-pop>
      <van-tabbar
        :border="false"
        style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
        "
      >
        <van-button
          style="height: 70%; width: 4rem"
          type="info"
          block
          round
          size="small"
          @click="agreePayMoney"
          >同意并确认支付</van-button
        >
        <van-button
          style="height: 70%; width: 100px; margin-left: 20px"
          type="default"
          block
          round
          size="small"
          @click="closePopup"
          >取消支付</van-button
        >
      </van-tabbar>
    </van-popup>
    <!-- 开票弹框页面 -->
    <invoice-page
      ref="invoice"
      :totalPrice="totalPrice"
      @getInvoiceParams="getInvoiceParams"
    ></invoice-page>
  </div>
</template>

<script>
import InvoicePage from "@/components/common/invoice";
import userAgreementPop from "@/components/newcommon/userAgreement";

import { getWxOpenIdUrl } from "../../../public/config.json";
import { wxpayFunc } from "@/utils/lib/wxpay.js";
import { ISCONPPONMA } from "@/assets/js/gb.js";
import { commonToast } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      oldUrl: "", // 上一个路由
      checked: false,
      loadingFlag: false,
      show: true,
      userProduct: [], // 产品列表
      radio: "1",
      coupon: "", // 优惠卷
      agentCode: "", // 运营商编码
      invoiceWord: "", // 发票显示文字
      invoiceData: {
        // 发票弹框的内容
        invoicetype: 1,
        invoiceheader: {
          headertype: 1,
          headername: "",
          headercode: "",
          officeaddress: "",
          mobilenumber: "",
          bankname: "",
          bankaccount: "",
        },
      },
      radioPay: "1",
      numValue: 5, // 文件夹个数
      numValueFp: 3, // 分屏个数
      wxImg: require("../../assets/shop/wx.png"),
      zfbImg: require("../../assets/shop/zfb.png"),
      totalPrice: 0, // 购物车中的总价 格式 0000
      totalMoney: 0, // 总价 格式 0.00
      totalPriceYou: 0,
      totalMoneyYou: 0,
      oldPrice: 0, // 原价
      years: [], // 主套餐选择年份优惠价格
      xufeiItem: {}, // 点击续费保存信息
      effectiveorders: [], // 已购商品数据
      gridItems: [], // 获取扩展功能包数据
      result: [],
      vipItemBuyDay: 0, // 续费天数
      discountdescdetail: [], // vip优惠信息
      productcodeMenu: "", // 主套餐的code
      productcodeMenuOrderId: "", // 订单id
      yearDiscountcode: "", // 主套餐优惠code
      dataForm: "", // 跳转地址
      userAgreement: false, // 用户协议
      vipUpgradeAgreement: false, // VIP升级协议
      userAgreementData: {}, // 合同返回得内容
      sumMoney: 0, // 合同中的合计
      iconCouponFlag: false, // 优惠码的错误提示信息 提示图标
      alertMessage: "", // 优惠码提示信息
      alertMessage_1: "", // 优惠码返回的优惠信息
      currentYearIndex: 0, // 选中的年份

      // 微信内支付
      wxpayObj: null,

      // 是否显示优惠码
      isConpponma: ISCONPPONMA,
    };
  },
  components: {
    InvoicePage,
    userAgreementPop,
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    wxopenid() {
      return this.$store.state.user.wxopenid;
    },
  },
  beforeRouteEnter(to, from, next) {
    // beforeRouteEnter 守卫不能访问 this，因为守卫在导航确认前被调用,因此即将登场的新组件还没被创建
    next((vm) => {
      // 通过 `vm` 访问组件实例,将值传入oldUrl
      vm.oldUrl = from.path;
    });
  },
  mounted() {
    this.firstGetInvoiceParams();
    this.getUserProduct();
    this.$nextTick(() => {
      // 验证是否获取到了上页的url
      console.log("this.oldUrl=======", this.oldUrl);
    });
  },
  methods: {
    // 年份切换
    changeYear(year, index) {
      console.log("index", year, index);
      this.currentYearIndex = index;
      this.year = year;
      this.yearDiscountcode = year.discountcode;
      this.oldPrice = Number(year.oriprice); // 原价
      this.totalMoney = Number(year.newprice);
      this.totalPrice = Number(year.newprice) * 100;

      this.totalMoneyYou = Number(year.newprice);
      this.totalPriceYou = Number(year.newprice) * 100;

      this.caleCouponCodeAndAgentCode();
    },
    closePopup() {
      if (this.oldUrl == "/myPrivilege") {
        this.$router.replace("myPrivilege");
      } else if (this.oldUrl == "/onlineMall") {
        this.$router.replace("onlineMall");
      } else {
        this.$router.replace("onlineMall");
      }
    },
    // 优惠码清除按钮
    clearCoupon() {
      this.checked = false;
    },
    changeChecked(name) {
      if (name == true) {
        this.caleCouponCodeAndAgentCode();
      } else {
        this.totalMoney = this.totalMoneyYou;
        this.totalPrice = this.totalPriceYou;
        this.alertMessage_1 = "";
      }
    },
    // 获取已订购的产品列表
    getUserProduct() {
      this.$http
        .reqGetUserProduct()
        .then((res) => {
          this.userProduct = res.items;
          if (this.userProduct != null && this.userProduct.length > 0) {
            this.xufei(this.userProduct[0], "main");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 续费按钮
    xufei(item, type) {
      this.xufeiItem = item;
      this.isConpponma = item.productcode === "000001" ? false : true;
      this.firstGetInvoiceParams();
      if (type == "main") {
        this.$http
          .reqGetProductDiscount(this.xufeiItem.productcode)
          .then((res) => {
            // 获取产品优惠列表
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.years = res.item;
                this.yearDiscountcode = this.years[0].discountcode;
                this.oldPrice = Number(this.years[0].oriprice);
                this.totalMoney = Number(this.years[0].newprice);
                this.totalPrice = Number(this.years[0].newprice) * 100;
                this.totalMoneyYou = Number(this.years[0].newprice);
                this.totalPriceYou = Number(this.years[0].newprice) * 100;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 获取发票弹框的内容
    getInvoiceParams(params, word) {
      //console.log("获取发票的内容===》》》父组件params", params, word);
      this.invoiceData = params;
      this.invoiceWord = word;
    },
    // 第一次获取已开发票的内容
    firstGetInvoiceParams() {
      this.$http
        .getInvoiceHeader()
        .then((res) => {
          console.log("第一次获取已开发票的内容res===>", res);
          if (res.rtncode === 1 && res.rltcode === 1 && res.item != null) {
            if (res.item.headertype === 1) {
              // 个人
              this.invoiceWord = "普通发票 个人";
              this.invoiceData.invoiceheader = res.item;
            } else if (res.item.headertype === 2) {
              // 公司
              this.invoiceWord = "普通发票 单位";
              this.invoiceData.invoiceheader = res.item;
            }
            this.$refs.invoice.inputMsg(res.item);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast("服务器开小差啦111,请刷新后重试!");
        });
    },
    // 发票
    drawABill() {
      this.$refs.invoice.openpopup();
      this.$refs.invoice.getTotalMoney(this.totalMoney);
    },
    // 计算优惠码和运营商编码优惠信息
    caleCouponCodeAndAgentCode() {
      if (this.checked) {
        let params = {
          amount: this.totalMoney,
          couponcode: this.coupon,
          agentcode: this.agentCode,
        };
        console.log("paramsparams", params);
        this.$http
          .reqCaleCouponCodeAndAgentCode(params)
          .then((res) => {
            console.log("计算优惠码和运营商编码优惠信息res===>", res);
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                if (res.item.couponrlt) {
                  this.iconCouponFlag = true;
                  this.alertMessage_1 = res.item.discountdesc;
                  this.totalMoney = res.item.amount;
                  this.totalPrice = res.item.amount * 100; // 折后价
                } else {
                  this.iconCouponFlag = false;
                  this.alertMessage = res.item.couponrltdesc;
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 续费中提交订单
    onSubmit() {
      if (!this.isConpponma) {
        this.onConfirm();
        return;
      }
      if (!this.checked) {
        this.alertDialog("您没有确认使用优惠码，是否继续下单？");
      } else {
        if (!this.iconCouponFlag) {
          this.alertDialog(`${this.alertMessage}，是否继续下单？`);
        } else if (this.iconCouponFlag) {
          this.onConfirm();
        }
      }
    },
    // 优惠码和运营商编码 弹框提示信息
    alertDialog(message) {
      this.$dialog
        .confirm({
          title: "提示",
          message: message,
          confirmButtonText: "下单",
        })
        .then(() => {
          // on confirm
          this.onConfirm();
        })
        .catch(() => {
          // on cancel
        });
    },
    onConfirm() {
      this.loadingFlag = true;
      if (this.radioPay === "1") {
        console.log("微信支付", sessionStorage.getItem("wxopenid"));
        if (
          !sessionStorage.getItem("wxopenid") &&
          Number(localStorage.getItem("WX_VERSION"))
        ) {
          console.log("this.wxopenid", this.wxopenid);
          this.$http
            .reqPostGetWeixinPromise({
              http_redirct: getWxOpenIdUrl,
            })
            .then((res) => {
              console.log("用户微信内登录点击确认支付按钮", res);
              location.href = res.item.url;
            })
            .catch((err) => {
              console.log("用户微信内登录点击确认支付按钮", err);
            });
        } else {
          this.isWeixin();
        }
      } else if (this.radioPay === "2") {
        console.log("支付宝支付");
      }
    },
    // 主套餐支付
    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("是微信浏览器", this.totalPrice / 100);

        let params = {
          product: this.xufeiItem.productcode, // 购买的产品
          discount: this.yearDiscountcode, // 选择的优惠方式
          paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付 32 微信内支付
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.agentCode, // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
          wxopenid: sessionStorage.getItem("wxopenid"),
        };
        console.log("微信内套餐支付请求参数params", params);

        this.$http
          .reqPostProductContinueOrder(params)
          .then((res) => {
            console.log("主套餐支付res===>", res);
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                console.log("主套餐支付微信内====>", res);
                // this.dataForm = res.result.strdata;
                this.wxpayObj = JSON.parse(res.result.strdata);
                console.log("主套餐支付this.wxpayObj", this.wxpayObj);
                this.getUserAgreement(res.result.orderid, "main");
              } else {
                commonToast(res.rltdesc, this);
              }
            }
          })
          .catch((err) => {
            console.log("续费出错====>", err);
          });
      } else {
        let params = {
          product: this.xufeiItem.productcode, // 购买的产品
          discount: this.yearDiscountcode, // 选择的优惠方式
          paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.agentCode, // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
        };
        console.log("主套餐支付请求参数params", params);
        this.$http
          .reqPostProductContinueOrder(params)
          .then((res) => {
            console.log("主套餐支付res===>", res);
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.dataForm = res.result.strdata;

                console.log("主套餐支付this.dataForm", this.dataForm);
                this.getUserAgreement(res.result.orderid, "main");
              } else {
                commonToast(res.rltdesc, this);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 获取用户协议的内容
    getUserAgreement(orderid, type) {
      console.log("orderid, type", orderid, type);

      this.$http
        .reqGetContractinfo(orderid)
        .then((res) => {
          console.log("获取用户协议的内容res===>", res);
          if (res.rtncode === 1 && res.rltcode === 1) {
            this.userAgreementData = res.item;
            console.log("this.userAgreementData", this.userAgreementData);
            this.userAgreementData.detail.forEach((item) => {
              this.sumMoney += item.amount;
            });
            console.log("this.sumMoney", this.sumMoney);
            if (type == "main") {
              this.userAgreement = true;
              this.$nextTick(() => {
                let dom = document.getElementById("word_11");
                dom.scrollIntoView();
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 同意并确认支付
    agreePayMoney() {
      if (Number(localStorage.getItem("WX_VERSION"))) {
        if (this.wxpayObj) {
          console.log("同意并确认支付是wx内", this.wxpayObj);
          wxpayFunc(this.wxpayObj, this.wxPayCallback);
        }
      } else {
        console.log("同意并确认支付this.dataForm", this.dataForm);
        location.href = this.dataForm;
      }
    },
    // 微信内支付回调函数
    wxPayCallback(res) {
      console.log("微信内支付完成====>", res);
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        this.$notify({
          type: "success",
          message: "用户支付成功!",
          duration: 5000,
        });
        this.loadingFlag = false;
        this.$http.refreshToken().then((res) => {
          this.bus.$emit("saveTokenHandle", res, 1);
          this.$router.push("/newFiles");
        });
      } else {
        this.$notify({
          type: "warning",
          message: "用户支付失败!",
          duration: 5000,
        });
        this.loadingFlag = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#xuFeiPage {
  background-color: #f7f7f7;
  padding-bottom: 2rem;
  .titleWord {
    padding: 10px 0 0;
  }
  .word_1 {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
  .payMethodsxf {
    margin: 0 10px;
    .word {
      margin: 14px 0;
    }
    /deep/.van-cell__title {
      display: flex;
      align-items: center;
    }
    .custom-title {
      margin-left: 10px;
    }
    .vip-box {
      background-color: #fff;
      padding: 10px 10px;
      .vip-box-item {
        display: flex;
        align-items: center;
        padding: 10px 0;
        .vip-title {
          flex: 0 0 60px;
          margin: 0 10px 0 10px;
        }
        .num {
          flex: 1;
        }
        .price {
          flex: 0 0 100px;
          text-align: right;
        }
      }
    }
    .chooseYear {
      margin: 16px 0;
      display: flex;
      text-align: center;
      justify-content: space-around;
      .one {
        border: 1px solid #f2f2f2;
        width: 30%;
        padding: 10px 0;
        border-radius: 6px;
        p {
          margin: 0;
        }
        .year {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 4px;
        }
        .yuan {
          margin-bottom: 4px;
          color: @--primary-color;
          .money {
            font-size: 18px;
            font-weight: bold;
          }
        }
        .yuanold {
          margin-bottom: 4px;
          font-size: 12px;
          color: #ccc;
        }
      }
      .yearActive {
        background-color: @--background-color;
        border: 1px solid #e5c693;
      }
    }
  }
  .line {
    width: 100%;
    height: 8px;
    background: #f6f6f6;
  }
  .van-tag {
    margin: 2px;
  }
  /deep/.van-cell--clickable:active {
    background-color: #fff;
  }
  /deep/.van-cell:not(:last-child)::after {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    top: 0;
  }
  .userAgreementContent {
    font-size: 14px;
    padding: 0 10px;
    margin-bottom: 3rem;
    & > h4 {
      margin-bottom: 0;
    }
    .contentItemP {
      & > p {
        text-indent: 20px;
        margin: 0;
        margin-top: 4px;
      }
      & > h5 {
        margin: 0;
        margin-top: 4px;
      }
    }
    .marginT {
      margin-top: 20px;
    }
    .zhangStyle {
      position: relative;
      & > img {
        position: absolute;
        top: 42%;
        left: 28%;
      }
    }
  }
}
</style>
